import { useCallback, useEffect } from 'react';

export function useTryRefreshData({
  refetch,
  forze,
  attempts,
  retryTime,
  callback,
}: {
  refetch: Function;
  forze?: boolean;
  attempts?: number;
  retryTime?: number;
  callback?: Function;
}) {
  const tryRefreshData = useCallback(() => {
    let tryCount = 0;
    const maxAttempts = attempts ?? 3;
    const intervalTime = retryTime ?? 5000;

    refetch();
    const intervalId = setInterval(() => {
      tryCount++;

      if (tryCount >= maxAttempts) {
        callback && callback();
        clearInterval(intervalId);
      } else {
        refetch();
      }
    }, intervalTime);
  }, [refetch, attempts, retryTime, callback]);

  useEffect(() => {
    const id = setTimeout(() => {
      if (forze) {
        tryRefreshData();
      }
    }, 50);
    return () => clearTimeout(id);
  }, [refetch, tryRefreshData, forze]);

  return { tryRefreshData };
}
